'use client';

import React from 'react';
import * as Styled from './BackToTop.styled';
import { ComponentContainer } from '@/components/atoms/ComponentContainer/ComponentContainer';
import { Typography } from '@/components/atoms/Typography/Typography';
import { Image } from '@/components/atoms/Image/Image';
import { ICommonProps } from '@/types/global';
import { Button } from '@/components/atoms/Button/Button';
import { scrollToTop } from '@/utils/generic';
import { usePageStore } from '@/store/usePageStore';

export interface IBackToTop extends ICommonProps {
  text: string;
  borderTop?: boolean;
}

export const BackToTop: React.FC<IBackToTop> = ({
  text,
  marginBottom = 'default',
  borderTop = true,
  width = 'main',
  isProject = false,
}) => {

  const locale = usePageStore((s) => s.locale);

  return (
    <ComponentContainer
      width={width}
      marginBottom={marginBottom}
      isProject={isProject}
      as="div"
    >
      <Styled.BackToTopContainer borderTop={borderTop}>
        <Button 
          callbackOnClick={() => scrollToTop()} 
          color='primary'
          aria-label={locale === 'en' ? 'Back to top' : 'Volver arriba'}
        >
          <Typography text={text} as="span" />
          <Image
            src="/img/icons//arrow-up.svg"
            alt="Arrow up"
            height={20}
            width={20}
            fill={false}
          />
        </Button>
      </Styled.BackToTopContainer>
    </ComponentContainer>
  );
};
